module.exports = __webpack_public_path__ + "static/img/duofangguangbo2.4c4d77a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/duofangguangbo2.png
// module id = u0Te
// module chunks = 24